import Select from "../../../../../components/Select/Select";
import Calendar from "../../../../../components/calendar/Calendar";
import CheckBox from "../../../../../components/checkBox/CheckBox";
import Input from "../../../../../components/inputText/Input";
import TextArea from "../../../../../components/TextArea/TextArea";
import React, {useEffect, useState} from "react";
import MediaQueryUtils from "../../../../../utils/MediaQueryUtils";
import Utils from "../../../../../utils/Utils";
import {setStateAssistente} from "../../../../../actions/IndexActions";
import {useDispatch, useSelector} from "react-redux";
import oggettiUtili from "../../../../../utils/OggettiUtili.json";
import $ from "jquery";

function DisponibilitaOfferta(props) {

    const [state, setState] = useState({})
    const [stateDate, setStateDate] = useState({})
    const [arrayComuniTotali, setArrayComuniTotali] = useState({})
    const comuni = JSON.parse(sessionStorage.getItem("comuniCoordinate"))
    const [preferenzeTerritoriali, setPreferenzeTerritoriali] = useState({})
    const selectOptions = oggettiUtili.statoDisponibilita
    const [countRender, setCountRender] = useState(0)
    let isPageWide = MediaQueryUtils('(min-width: 1150px)')
    const dispatch = useDispatch();
    const getAssistente = useSelector(state => state.wizardReducer)

    useEffect(() => {
        if (getAssistente && getAssistente.disponibilitaOfferta) {
            let newState = getAssistente.disponibilitaOfferta
            setState(newState)
            if (getAssistente.disponibilitaOfferta && getAssistente.disponibilitaOfferta.comune) {
                setArrayComuniTotali(splitComuniPerProvincia([...getAssistente.disponibilitaOfferta.comune]))
                setPreferenzeTerritoriali({...getAssistente.disponibilitaOfferta.preferenzeTerritoriali})
            }
            setCountRender(countRender + 1)
        }
    }, [])

    useEffect(() => {
        validateCampiCondizionati()
        dispatch(setStateAssistente("disponibilitaOfferta", state))
    }, [state, setState])

    useEffect(() => {
        if (stateDate && Object.keys(stateDate).length !== 0) {
            setState({...state, ...stateDate})
            setStateDate({})
        }
    }, [Object.keys(stateDate).length !== 0])

    function validateCampiCondizionati() {
        if (Object.keys(state).length !== 0) {
            if (!(state.disponibilitaAssistenza && state.disponibilitaAssistenza.altro) && state.disponibilitaAssistenza && state.disponibilitaAssistenza.altroSpecificare) {
                delete state.disponibilitaAssistenza.altroSpecificare
            }
        }
    }

    function onChangeCalendar(id, value) {
        setStateDate(Utils.riceviValore(stateDate, id, value))
    }

    function isDataDisponibileDaNonValida() {
        return !!(state && Utils.isValorizzato(state.disponibileDa) && !Utils.isDateItaValid(state.disponibileDa))
    }

    $(function () {
        let e = $('[data-toggle="popoverComuni"]').popover({
            html: true,
            content: '<span class="popover-content">Selezionando la voce Tutta la Regione viene automaticamente espressa una preferenza per tutti i comuni della Regione del Veneto</span>'
        });
        e = e.data('bs.popover') && e.data('bs.popover').getTipElement() ? e.data('bs.popover').getTipElement() : null
        $(e).addClass("custom");
    });

    function splitComuniPerProvincia(arrayComuni) {
        let belluno = [], padova = [], rovigo = [], treviso = [], venezia = [], verona = [], vicenza = []
        if (arrayComuni) {
            arrayComuni.forEach(comune => {
                if (comune.codice.startsWith("025")) {
                    belluno.push(comune.codice)
                } else if (comune.codice.startsWith("028")) {
                    padova.push(comune.codice)
                } else if (comune.codice.startsWith("029")) {
                    rovigo.push(comune.codice)
                } else if (comune.codice.startsWith("026")) {
                    treviso.push(comune.codice)
                } else if (comune.codice.startsWith("027")) {
                    venezia.push(comune.codice)
                } else if (comune.codice.startsWith("023")) {
                    verona.push(comune.codice)
                } else if (comune.codice.startsWith("024")) {
                    vicenza.push(comune.codice)
                }
            })
        }
        return {
            belluno: belluno,
            padova: padova,
            rovigo: rovigo,
            treviso: treviso,
            venezia: venezia,
            verona: verona,
            vicenza: vicenza
        }
    }

    function onChangeCheckComuni(id, value, arrayProvincia, codiceProvincia) {
        let newPreferenzeTerritoriali = {...preferenzeTerritoriali}
        let newArrayComuniTotali = {...arrayComuniTotali}
        let newState = {...state}
        if (id === "regione") {
            if (value) {
                newArrayComuniTotali = splitComuniPerProvincia(comuni)
                newPreferenzeTerritoriali.provinciaBelluno = true
                newPreferenzeTerritoriali.provinciaPadova = true
                newPreferenzeTerritoriali.provinciaRovigo = true
                newPreferenzeTerritoriali.provinciaTreviso = true
                newPreferenzeTerritoriali.provinciaVenezia = true
                newPreferenzeTerritoriali.provinciaVerona = true
                newPreferenzeTerritoriali.provinciaVicenza = true
            } else {
                newArrayComuniTotali = splitComuniPerProvincia([])
                newPreferenzeTerritoriali.provinciaBelluno = false
                newPreferenzeTerritoriali.provinciaPadova = false
                newPreferenzeTerritoriali.provinciaRovigo = false
                newPreferenzeTerritoriali.provinciaTreviso = false
                newPreferenzeTerritoriali.provinciaVenezia = false
                newPreferenzeTerritoriali.provinciaVerona = false
                newPreferenzeTerritoriali.provinciaVicenza = false
            }
        } else if (value) {
            let arrayFiltrato = []
            comuni.forEach(comune => {
                if (comune.codice.startsWith(codiceProvincia)) arrayFiltrato.push(comune.codice)
            })
            newArrayComuniTotali[arrayProvincia] = arrayFiltrato
        } else {
            newArrayComuniTotali[arrayProvincia] = []
        }
        newPreferenzeTerritoriali[id] = value
        setArrayComuniTotali(newArrayComuniTotali)
        setPreferenzeTerritoriali(newPreferenzeTerritoriali)
        newState.comune = createComuniDaSalvare(newArrayComuniTotali)
        newState.preferenzeTerritoriali = newPreferenzeTerritoriali
        setState(newState)
    }

    function onChangeComuni(id, selectedOptions) {
        let newArrayComuniTotali = {...arrayComuniTotali}
        let newState = {...state}
        let newSelectedOptions = []
        for (let i = 0; i < selectedOptions.length; i++) {
            newSelectedOptions.splice(i, 1, selectedOptions[i].value)
        }
        newArrayComuniTotali[id] = newSelectedOptions
        setArrayComuniTotali(newArrayComuniTotali)
        newState.comune = createComuniDaSalvare(newArrayComuniTotali)
        setState(newState)
    }

    function createComuniDaSalvare(newArrayComuniTotali){
        let codiciComuniDaSalvare = []
        for (const array in newArrayComuniTotali) {
            codiciComuniDaSalvare = codiciComuniDaSalvare.concat(newArrayComuniTotali[array])
        }
        let comuniDaSalvare = []
        codiciComuniDaSalvare.forEach(comune => {
            comuni.forEach(comuneTotale => {
                if(comune === comuneTotale.codice){
                    comuniDaSalvare.push(comuneTotale)
                }
            })
        })

        return comuniDaSalvare
    }

    return (
        <div>
            {isPageWide ?
                <div className={"row"}>
                    <div className={"col-3"}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Stato:</span>
                        <span className={"obbligatorietaColor"}>*</span>
                        <br/>
                        <Select id={"stato"} ariaLabel={"Stato occupazionale"}
                                value={state && state.stato ? state.stato : ""}
                                onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                                options={selectOptions}/>
                    </div>
                    <div className={"col-7"}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Disponibile da:</span>
                        <br/>
                        <div style={{width: "40%"}}>
                            <Calendar id={"disponibileDa"}
                                      ariaLabel={"Disponibile da"}
                                      value={state && state.disponibileDa ? state.disponibileDa : ""}
                                      onChange={onChangeCalendar}
                                      errorClause={isDataDisponibileDaNonValida()}
                                      errorMessage={"La data non è valida"}/>
                        </div>
                    </div>
                    <div className={"col-2"} style={{marginTop: ".6rem"}}>
                        <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                    </div>
                </div>
                :
                <div className={"row"}>
                    <div className={"col-7"}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Stato:</span>
                        <br/>
                        <Select id={"stato"} ariaLabel={"Stato occupazionale"}
                                value={state && state.stato ? state.stato : ""}
                                onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                                options={selectOptions}/>
                    </div>
                    <div className={"col-5"} style={{marginTop: ".6rem"}}>
                        <span style={{color: "red", fontWeight: "bold"}}>*Campo Obbligatorio</span>
                    </div>
                    <div className={"col-7"}>
                        <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Disponibile da:</span>
                        <br/>
                        <Calendar id={"disponibileDa"}
                                  ariaLabel={"Disponibile da"}
                                  value={state && state.disponibileDa ? state.disponibileDa : ""}
                                  onChange={onChangeCalendar}
                                  errorClause={isDataDisponibileDaNonValida()}
                                  errorMessage={"La data non è valida"}/>

                    </div>
                </div>
            }

            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Indicare la disponibilità ad assistere:</span>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "65%" : "50%"}}>
                <CheckBox id={"maschio"}
                          text={"Maschio"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.maschio ? state.disponibilitaAssistenza.maschio : false}/>
                <CheckBox id={"femmina"}
                          text={"Femmina"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.femmina ? state.disponibilitaAssistenza.femmina : false}/>
                <CheckBox id={"autosufficiente"}
                          text={"Persona autosufficiente"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.autosufficiente ? state.disponibilitaAssistenza.autosufficiente : false}/>
                <CheckBox id={"carrozzina"}
                          text={"Persona in carrozzina"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.carrozzina ? state.disponibilitaAssistenza.carrozzina : false}/>
                <CheckBox id={"allettata"}
                          text={"Persona allettata"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.allettata ? state.disponibilitaAssistenza.allettata : false}/>
                <CheckBox id={"parzialmenteAutosufficiente"}
                          text={"Persona parzialmente autosufficiente"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.parzialmenteAutosufficiente ? state.disponibilitaAssistenza.parzialmenteAutosufficiente : false}/>
                <CheckBox id={"disabilita"}
                          text={"Persona affetta da disabilità mentale/psichiatrica/demenza"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                          checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.disabilita ? state.disponibilitaAssistenza.disabilita : false}/>
                <div className={"row"}>
                    <div className={"col-3"}>
                        <CheckBox id={"altro"}
                                  text={"Altro"}
                                  onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaAssistenza"))}
                                  checked={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.altro ? state.disponibilitaAssistenza.altro : false}/>
                    </div>
                    <div className={"col-9"}>
                        <Input id={"altroSpecificare"}
                               ariaLabel={"Disponibilità ad assistere: altro, specificare"}
                               placeholder={"Specificare"}
                               value={state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.altroSpecificare ? state.disponibilitaAssistenza.altroSpecificare : ""}
                               onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.value, "disponibilitaAssistenza"))}
                               disabled={!(state && state.disponibilitaAssistenza && state.disponibilitaAssistenza.altro)}/>
                    </div>
                </div>
            </div>

            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Come assistente, si sente in grado di occuparsi di:</span>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}/>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>Ho esperienza</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>Lo posso fare</div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Igiene intima</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"igieneIntimaEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.igieneIntimaEsperienza ? state.assistenteOccuparsiDi.igieneIntimaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"igieneIntimaPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.igieneIntimaPossoFare ? state.assistenteOccuparsiDi.igieneIntimaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Doccia</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"docciaEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.docciaEsperienza ? state.assistenteOccuparsiDi.docciaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"docciaPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.docciaPossoFare ? state.assistenteOccuparsiDi.docciaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Spugnatura a letto e lavaggio capelli</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spugnaturaLavaggioEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.spugnaturaLavaggioEsperienza ? state.assistenteOccuparsiDi.spugnaturaLavaggioEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spugnaturaLavaggioPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.spugnaturaLavaggioPossoFare ? state.assistenteOccuparsiDi.spugnaturaLavaggioPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Taglio della barba</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioBarbaEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.taglioBarbaEsperienza ? state.assistenteOccuparsiDi.taglioBarbaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioBarbaPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.taglioBarbaPossoFare ? state.assistenteOccuparsiDi.taglioBarbaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Taglio delle unghie</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioUnghieEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.taglioUnghieEsperienza ? state.assistenteOccuparsiDi.taglioUnghieEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"taglioUnghiePossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.taglioUnghiePossoFare ? state.assistenteOccuparsiDi.taglioUnghiePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Movimentazione della persona</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"movimentazionePersonaEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.movimentazionePersonaEsperienza ? state.assistenteOccuparsiDi.movimentazionePersonaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"movimentazionePersonaPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.movimentazionePersonaPossoFare ? state.assistenteOccuparsiDi.movimentazionePersonaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Utilizzo del sollevatore</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"utilizzoSollevatoreEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.utilizzoSollevatoreEsperienza ? state.assistenteOccuparsiDi.utilizzoSollevatoreEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"utilizzoSollevatorePossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi"))}
                              checked={state && state.assistenteOccuparsiDi && state.assistenteOccuparsiDi.utilizzoSollevatorePossoFare ? state.assistenteOccuparsiDi.utilizzoSollevatorePossoFare : false}/>
                </div>
            </div>

            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Come assistente, si sente in grado di occuparsi di:</span>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}/>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>Ho esperienza</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>Lo posso fare</div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Lavare</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"lavareEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.lavareEsperienza ? state.assistenteOccuparsiDi2.lavareEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"lavarePossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.lavarePossoFare ? state.assistenteOccuparsiDi2.lavarePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Stirare</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"stirareEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.stirareEsperienza ? state.assistenteOccuparsiDi2.stirareEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"stirarePossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.stirarePossoFare ? state.assistenteOccuparsiDi2.stirarePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Preparazione pasti/diete speciali</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"preparazionePastiEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.preparazionePastiEsperienza ? state.assistenteOccuparsiDi2.preparazionePastiEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"preparazionePastiPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.preparazionePastiPossoFare ? state.assistenteOccuparsiDi2.preparazionePastiPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Pulizie di casa</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"pulizieCasaEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.pulizieCasaEsperienza ? state.assistenteOccuparsiDi2.pulizieCasaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"pulizieCasaPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.pulizieCasaPossoFare ? state.assistenteOccuparsiDi2.pulizieCasaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Visite mediche</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"visiteMedicheEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.visiteMedicheEsperienza ? state.assistenteOccuparsiDi2.visiteMedicheEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"visiteMedichePossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.visiteMedichePossoFare ? state.assistenteOccuparsiDi2.visiteMedichePossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Fare la spesa</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spesaEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.spesaEsperienza ? state.assistenteOccuparsiDi2.spesaEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"spesaPossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.spesaPossoFare ? state.assistenteOccuparsiDi2.spesaPossoFare : false}/>
                </div>
            </div>
            <div className={"row"}>
                <div className={isPageWide ? "col-3" : "col-6"}>Disbrigo semplici pratiche burocratiche</div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"praticheBurocraticheEsperienza"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.praticheBurocraticheEsperienza ? state.assistenteOccuparsiDi2.praticheBurocraticheEsperienza : false}/>
                </div>
                <div className={isPageWide ? "col-2" : "col-3"} style={{textAlign: "center"}}>
                    <CheckBox id={"praticheBurocratichePossoFare"}
                              onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenteOccuparsiDi2"))}
                              checked={state && state.assistenteOccuparsiDi2 && state.assistenteOccuparsiDi2.praticheBurocratichePossoFare ? state.assistenteOccuparsiDi2.praticheBurocratichePossoFare : false}/>
                </div>
            </div>


            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Si sente in grado di assistere persone con:</span>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "60%" : "25%"}}>
                <CheckBox text={"Catetere"}
                          id={"catetere"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenzaPersone"))}
                          checked={state && state.assistenzaPersone && state.assistenzaPersone.catetere ? state.assistenzaPersone.catetere : false}/>
                <CheckBox text={"Peg"}
                          id={"peg"}

                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenzaPersone"))}
                          checked={state && state.assistenzaPersone && state.assistenzaPersone.peg ? state.assistenzaPersone.peg : false}/>
                <CheckBox text={"Stomia"}
                          id={"stomia"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenzaPersone"))}
                          checked={state && state.assistenzaPersone && state.assistenzaPersone.stomia ? state.assistenzaPersone.stomia : false}/>
                <CheckBox text={"Ventilatore polmonare"}
                          id={"ventilatorePolmonare"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenzaPersone"))}
                          checked={state && state.assistenzaPersone && state.assistenzaPersone.ventilatorePolmonare ? state.assistenzaPersone.ventilatorePolmonare : false}/>
                <CheckBox text={"Ossigeno"}
                          id={"ossigeno"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "assistenzaPersone"))}
                          checked={state && state.assistenzaPersone && state.assistenzaPersone.ossigeno ? state.assistenzaPersone.ossigeno : false}/>
            </div>
            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Indicare la disponibilità settimanale di assistenza:</span>
                <span className={"obbligatorietaColor"}>*</span>
            </div>
            <div className={"row"} style={{justifyContent: "space-between", width: isPageWide ? "60%" : "55%"}}>
                <CheckBox text={"Assistenza h24/24"}
                          id={"h24"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.h24 ? state.disponibilitaSettimanale.h24 : false}/>
                <CheckBox text={"Assistenza diurna"}
                          id={"assistenzaDiurna"}
                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.assistenzaDiurna ? state.disponibilitaSettimanale.assistenzaDiurna : false}/>
                <CheckBox text={"Assistenza notturna"}
                          id={"assistenzaNotturna"}

                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.assistenzaNotturna ? state.disponibilitaSettimanale.assistenzaNotturna : false}/>
                <CheckBox text={"Assistenza fine settimana"}
                          id={"assistenzaFineSettimana"}

                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.assistenzaFineSettimana ? state.disponibilitaSettimanale.assistenzaFineSettimana : false}/>
                <CheckBox text={"Assistenza a chiamata per sostituzione malattia/ferie"}
                          id={"assistenzaChiamata"}

                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.assistenzaChiamata ? state.disponibilitaSettimanale.assistenzaChiamata : false}/>
                <CheckBox text={"Con vitto"}
                          id={"vitto"}

                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.vitto ? state.disponibilitaSettimanale.vitto : false}/>
                <CheckBox text={"Con alloggio"}
                          id={"alloggio"}

                          onChange={(event) => setState(Utils.riceviValorePadre(state, event.target.id, event.target.checked, "disponibilitaSettimanale"))}
                          checked={state && state.disponibilitaSettimanale && state.disponibilitaSettimanale.alloggio ? state.disponibilitaSettimanale.alloggio : false}/>
            </div>


            <div style={{marginTop: "1rem"}}>
                <span style={{fontWeight: "bold", fontSize: "14px", color: "#505050"}}>Indicare la propria preferenza territoriale:</span>
                <span className={"obbligatorietaColor"}>*</span><br/>
                <label style={{fontSize: "14px"}}>La famiglia cercherà l'assistente familiare all'interno dei comuni
                    selezionati</label>
            </div>
            <div className={"row"} style={{alignItems: "center"}}>
                <div className={"col-2"} style={{maxWidth: "180px"}}>
                    <CheckBox id={"regione"}
                              text={"Tutta la regione"}
                              onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked)}
                              checked={preferenzeTerritoriali.regione}/>
                </div>
                <div className={"col-8"} style={{cursor: "pointer"}}>
                    <a data-toggle="popoverComuni" data-container="body" data-trigger="hover">
                        <svg width="22" height="22" id="it-info-circle" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 19a9 9 0 119-9 9 9 0 01-9 9zm-.7-15h1.5v2h-1.5zm0 3h1.5v9h-1.5z"/>
                            <path fill="none" d="M0 0h24v24H0z"/>
                        </svg>
                    </a>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-6"}>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaBelluno"}
                                      text={"Provincia di Belluno"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "belluno", "025")}
                                      checked={preferenzeTerritoriali.provinciaBelluno}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"belluno"} ariaLabel={"Comuni della provincia di Belluno"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("025")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.belluno ?? []}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaBelluno}
                            />
                        </div>


                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaPadova"}
                                      text={"Provincia di Padova"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "padova", "028")}
                                      checked={preferenzeTerritoriali.provinciaPadova}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"padova"} ariaLabel={"Comuni della provincia di Padova"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("028")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.padova ?? []}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaPadova}
                            />
                        </div>


                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaRovigo"}
                                      text={"Provincia di Rovigo"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "rovigo", "029")}
                                      checked={preferenzeTerritoriali.provinciaRovigo}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"rovigo"} ariaLabel={"Comuni della provincia di Rovigo"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("029")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaRovigo}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.rovigo ?? []}
                            />
                        </div>


                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaTreviso"}
                                      text={"Provincia di Treviso"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "treviso", "026")}
                                      checked={preferenzeTerritoriali.provinciaTreviso}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"treviso"} ariaLabel={"Comuni della provincia di Treviso"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("026")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.treviso ?? []}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaTreviso}

                            />
                        </div>


                    </div>
                </div>
                <div className={"col-6"}>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaVenezia"}
                                      text={"Provincia di Venezia"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "venezia", "027")}
                                      checked={preferenzeTerritoriali.provinciaVenezia}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"venezia"} ariaLabel={"Comuni della provincia di Venezia"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("027")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.venezia ?? []}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaVenezia}

                            />
                        </div>


                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaVerona"}
                                      text={"Provincia di Verona"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "verona", "023")}
                                      checked={preferenzeTerritoriali.provinciaVerona}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"verona"} ariaLabel={"Comuni della provincia di Verona"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("023")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.verona ?? []}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaVerona}

                            />
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-4"}>
                            <CheckBox id={"provinciaVicenza"}
                                      text={"Provincia di Vicenza"}
                                      disabled={preferenzeTerritoriali.regione}
                                      onChange={(event) => onChangeCheckComuni(event.target.id, event.target.checked, "vicenza", "024")}
                                      checked={preferenzeTerritoriali.provinciaVicenza}/>
                        </div>
                        <div className={"col-8"}>
                            <Select id={"vicenza"} ariaLabel={"Comuni della provincia di Vicenza"}
                                    functionMap={comuni.map((oggetto) => {
                                        if (oggetto.codice.startsWith("024")) {
                                            return (
                                                <option
                                                    key={oggetto.codice}
                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        }
                                    })}
                                    multiple={true}
                                    autocomplete={true}
                                    onChange={(event) => onChangeComuni(event.target.id, event.currentTarget.selectedOptions)}
                                    value={arrayComuniTotali.vicenza ?? []}
                                    disabled={preferenzeTerritoriali.regione || preferenzeTerritoriali.provinciaVicenza}

                            />
                        </div>
                    </div>
                </div>
            </div>


            <div style={{marginTop: "1rem"}}>
                <span style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#505050"
                }}>Indicare eventuali richieste:</span>
            </div>
            <div style={{width: "50%"}}>
                <TextArea id={"eventualiRichieste"} rows={"5"}
                          ariaLabel={"Indicare eventuali richieste"}
                          value={state && state.eventualiRichieste ? state.eventualiRichieste : ""}
                          onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                          placeholder={"Eventuali richieste"}/>
            </div>

        </div>
    )
}

export default DisponibilitaOfferta
